import React from "react";

import { Box, Typography, Button, Alert } from "@mui/material";

import ModernModal from "../ModernModal";

interface CreditsWarningModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export default function CreditsWarningModal({
  open,
  onClose,
  onConfirm,
}: CreditsWarningModalProps) {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <ModernModal
      open={open}
      onClose={onClose}
      title="Additional Credits Required"
      maxWidth="sm"
      actions={
        <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
          <Button variant="outlined" onClick={onClose} sx={{ minWidth: 100 }}>
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleConfirm}
            sx={{ minWidth: 100 }}
          >
            Confirm
          </Button>
        </Box>
      }
    >
      <Box sx={{ textAlign: "center", py: 2 }}>
        <Alert severity="warning" sx={{ mb: 3, textAlign: "left" }}>
          <Typography variant="body2">Need More Prompts?</Typography>
        </Alert>

        <Typography variant="body2" color="text.secondary">
          You’ve used all the prompts included in your current plan. If you’d
          like to continue, this action will cost 5 credits.
        </Typography>
      </Box>
    </ModernModal>
  );
}
